import primengDe from '../assets/i18n/primeng-de.json';
import _primengEn from '../assets/i18n/primeng-en.json';

export function getPrimeNGTranslation(): Record<string, any> {
  const supportedLanguages = ['en', 'de'];
  const browserLang = navigator.language.split('-')[0];
  const _selectedLang = supportedLanguages.includes(browserLang) ? browserLang : 'de';

  return primengDe['de-AT'];
  // switch (selectedLang) {
  //   case 'en':
  //     return primengEn['en'];
  //   case 'de':
  //   default:
  //     return primengDe['de-AT'];
  // }
}